<template>
    <div>
        <sticky :className="'sub-navbar draft'">
            <el-button v-loading="saveLoading" type="primary" @click="save">保存</el-button>
        </sticky>

        <div style="padding: 10px;">
            <el-card class="box-card" style="width: 50%">
                <div slot="header" class="clearfix">
                    <span>功能明细</span>
                </div>
                <el-form ref="form" :model="form" :rules="formRules" label-width="80px">
                    <el-form-item label="功能名称" prop="name">
                        <el-input style="width: 300px" v-model="form.name"></el-input>
                    </el-form-item>
                    <el-form-item label="平台" prop="sys">
                        <el-col :span="8">
                            <el-select style="width: 200px" class="filter-item" v-model="form.sys">
                                <el-option label="运营管理平台" value="PT1">
                                </el-option>
                                <!-- <el-option label="线索聚合平台" value="PT2">
                                </el-option> -->
                            </el-select>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="路径" prop="path">
                        <el-input style="width: 300px" v-model="form.path"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="排序">
                        <el-input-number style="width: 120px" v-model="form.sort" :min="1" :max="100"></el-input-number>
                    </el-form-item> -->
                </el-form>
            </el-card>

            <el-card class="box-card" style="margin-top:20px;width: 50%">
                <div slot="header" class="clearfix">
                    <span>子功能</span>
                    <el-button style="float: right; padding: 3px 0" type="text" @click="showAddDialog">添加</el-button>
                </div>

                <el-table :data="records" border fit highlight-current-row style="width: 100%">
                    <el-table-column align="left" label="功能名称">
                        <template slot-scope="scope">
                            <span>{{scope.row.name}}</span>
                        </template>
                    </el-table-column>

                    <el-table-column align="left" label="功能标识">
                        <template slot-scope="scope">
                            <span>{{scope.row.identify}}</span>
                        </template>
                    </el-table-column>

                    <el-table-column align="center" label="操作" width="60">
                        <template slot-scope="scope">
                            <el-button type="warning" circle size="mini" icon="el-icon-delete" @click="deleteFunc(scope.$index)"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
        </div>

        <el-dialog title="添加子功能" :visible.sync="newDialogVisible" width="30%">
            <el-form ref="newForm" :model="newForm" :rules="newFormRules" label-position="right" label-width="120px">
                <el-form-item label="名称" prop="name">
                    <el-input style="width: 200px" v-model="newForm.name"></el-input>
                </el-form-item>
                <el-form-item label="标识" prop="identify">
                    <el-input style="width: 200px" v-model="newForm.identify"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="newDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="addFunc">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import Sticky from "@/components/Sticky"; // 粘性header组件

export default {
    name: "SystemFunctionsAdd",
    components: {
        Sticky
    },
    data() {
        return {
            saveLoading: false,
            form: {
                name: "",
                sys: "",
                path: "",
                sort: 0
            },
            records: [],
            newDialogVisible: false,
            newForm: {
                name: "",
                identify: "",
            },

            formRules: {
                name: [{
                    required: true,
                    message: '请输入功能名称',
                    trigger: 'blur'
                }, {
                    min: 1,
                    max: 50,
                    message: '长度应在1-50位',
                    trigger: 'blur'
                }],
                sys: [{
                    required: true,
                    message: '请选择平台',
                    trigger: 'blur'
                }],
                path: [{
                    required: true,
                    message: '请输入功能名称',
                    trigger: 'blur'
                }]
            },

            newFormRules: {
                name: [{
                    required: true,
                    message: '请输入子功能名称',
                    trigger: 'blur'
                }, {
                    min: 1,
                    max: 50,
                    message: '长度应在1-50位',
                    trigger: 'blur'
                }],
                identify: [{
                    required: true,
                    message: '请输入子功能标识',
                    trigger: 'blur'
                }, {
                    min: 1,
                    max: 50,
                    message: '长度应在1-50位',
                    trigger: 'blur'
                }],
            }
        };
    },

    methods: {
        save() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    this.saveLoading = true;
                    var parent = this;
                    this.$httpAuth
                        .post("/v1/backendFunctionRpc/add", {
                            sys: this.form.sys,
                            name: this.form.name,
                            path: this.form.path,
                            sort: this.form.sort,
                            subs: JSON.stringify(this.records)
                        })
                        .then(function (response) {
                            parent.saveLoading = false;
                            parent.$alert("保存成功", "添加功能", {
                                confirmButtonText: "关闭",
                                callback: action => {
                                    parent.$store.dispatch("delCurrentView");
                                    parent.$router.push("/system/functions/list");
                                }
                            });
                        })
                        .catch(() => {
                            parent.saveLoading = false;
                        });
                }
            });

        },
        showAddDialog() {
            this.newForm = {
                name: "",
                identify: "",
            }
            this.newDialogVisible = true;
            if (this.$refs['newForm']) {
                this.$refs['newForm'].resetFields();
            }
        },
        addFunc() {
            this.$refs['newForm'].validate((valid) => {
                if (valid) {
                    this.records.push(this.newForm)
                    this.newDialogVisible = false
                }
            });

        },
        deleteFunc(index) {
            this.records.splice(index, 1)
        }
    }
};
</script>

<style>

</style>
